export enum ClubType {
    UserDefined = 0,
    System      = 1
}
